import xhrSend from './/xhrSend';

function encodeQueryString(obj) {
  if (obj == null) {
    return null;
  }

  let output = [];
  for (let p in obj) {
    if (obj.hasOwnProperty(p)) {
      output.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }

  return output.join('&');
}

export default function c5_xhr(options, callback) {
  let xhr_options = {
    url: window.baseurl + options.url,
    data: encodeQueryString(options.data),
    timeout: 10000,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  };

  let xhr_callback = function(status, text, res) {
    if (callback == null) {
      return;
    }

    if (status === 'success') {
      let data;

      try {
        data = JSON.parse(text);
      } catch(e) {
        callback('parseerror', null, res);
        return;
      }

      callback(status, data, res);
    } else {
      callback(status, null, res);
    }
  };

  xhrSend(xhr_options, xhr_callback);
}
